<div class="chatButton">
    <bm-chat ></bm-chat>
</div>
<bm-enterprise-info></bm-enterprise-info>
<bm-nav [items]="menuItems" ></bm-nav>
<router-outlet></router-outlet>
<bm-footer></bm-footer>